// extracted by mini-css-extract-plugin
export default {"main":"ProjectWells_main__itbey","header":"ProjectWells_header__kLwbB","table":"ProjectWells_table__7K2Ek"};